import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Sirve para cualquier universidad?',
    a: 'Sí. UBA, UNLP, UNC, UADE, UCES, Siglo 21 y la mayoría de las universidades del país. El programa de Psicología General es el mismo — lo que varía es el énfasis de cada cátedra, y para eso están los recuadros CLAVE DE CÁTEDRA.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Por email inmediatamente después de la compra. Acceso en menos de 5 minutos. Descargás los PDFs y estudiás desde cualquier dispositivo — sin internet una vez descargados.'
  }, {
    q: '¿Qué diferencia tiene con los resúmenes de internet?',
    a: 'Los resúmenes de internet tienen errores conceptuales frecuentes, no están adaptados al formato de parcial argentino y no incluyen simulacros, flashcards ni planner. El MegaPack fue desarrollado con foco en exactamente lo que preguntan los docentes argentinos.'
  }, {
    q: '¿Funciona si el parcial es la semana que viene?',
    a: 'Sí. El Bono 3 (Planner 48 Horas) y el Bono 2 (Guía Anti-Pánico) están diseñados específicamente para eso.'
  }];
  return <section className="py-14 px-4 max-w-3xl mx-auto" data-id="element-110">
      <FadeIn data-id="element-111">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-10 flex items-center justify-center gap-3" data-id="element-112">
          <span className="text-4xl" data-id="element-113">❓</span> PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-4" data-id="element-114">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} data-id="element-115" />)}
        </div>
      </FadeIn>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-gray-800 rounded-xl bg-gray-900/50 overflow-hidden" data-id="element-116">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-117">
        <span className="font-bold text-lg text-gray-200" data-id="element-118">{question}</span>
        <ChevronDown className={`text-sky-500 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} size={20} data-id="element-119" />
      </button>
      <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-120">
        <p className="text-gray-400 leading-relaxed" data-id="element-121">{answer}</p>
      </div>
    </div>;
}